import { Card, Row, Col, Button } from 'react-bootstrap';
import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import InputWeekStartDatePicker from 'components/common/InputWeekStartDatePicker';
import SpAccountManagerDropdown from 'components/dropdowns/SpSalePerson/SpAccountManagerDropdown';
const KpiSummaryFilter = ({
  formData,
  handleChange,
  handleSubmit,
  style,
  displayOption = {},
  isFromManagerPage
}) => {
  return (
    <Card>
      <Card.Body className="bg-light">
        <Row style={style}>
          <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
            <InputWeekStartDatePicker
              column="date"
              displayName="W/C date"
              selected={formData?.date}
              handleChange={handleChange}
            />
          </Col>
          {isFromManagerPage && (
            <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
              <Form.Label className="fs-0 required">Account Manager</Form.Label>
              <SpAccountManagerDropdown
                fieldName="saleId"
                handleChange={(key, value) => handleChange(key, value?.id)}
                selectedOptions={formData?.saleId}
                // hasError={hasDropdownError}
                // required
                // showError={isSubmitted}
              />
             
            </Col>
          )}
        </Row>
      </Card.Body>
      {displayOption && displayOption.showFooter && (
        <Card.Footer>
          <hr />
          <div className="text-center mt-2">
            <Button color="primary" onClick={handleSubmit}>
              Search
            </Button>
          </div>
        </Card.Footer>
      )}
    </Card>
  );
};
KpiSummaryFilter.propTypes = {
  formData: PropTypes.object,
  displayOption: PropTypes.object,
  handleSubmit: PropTypes.func,
  saveConfig: PropTypes.func,
  style: PropTypes.object,
  handleChange: PropTypes.func,
  searchKeyword: PropTypes.string,
  isParentFullRow: PropTypes.bool,
  isFromManagerPage: PropTypes.bool
};

export default KpiSummaryFilter;
